import { UseragentDetails } from '@/components/app/types';
import { FC, ReactNode, createContext, useEffect, useState } from 'react';
import { getDeviceType, parseUserAgent } from '@/helpers/userAgent';
interface DeviceProviderProps {
  ua: UseragentDetails;
  children: ReactNode;
}
export const DeviceContext = createContext<UseragentDetails | null>(null);
const DeviceProvider: FC<DeviceProviderProps> = ({
  children,
  ua
}) => {
  const [userAgent, setUserAgent] = useState(ua);
  useEffect(() => {
    if (!userAgent) {
      const clientUserAgent = {
        ...parseUserAgent(navigator.userAgent),
        ...getDeviceType(window.innerWidth)
      };
      setUserAgent(clientUserAgent);
    }
    const handleResize = () => {
      setUserAgent(prev => ({
        ...prev,
        ...getDeviceType(window.innerWidth)
      }));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return <DeviceContext.Provider value={userAgent} data-sentry-element="unknown" data-sentry-component="DeviceProvider" data-sentry-source-file="DeviceProvider.tsx">
      {children}
    </DeviceContext.Provider>;
};
export default DeviceProvider;